import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";
import toastError from "../errors/toastError";

export function isQuickMessageMediaNotFound(err, blob) {
  const status = err?.response?.status;
  if (status === 404 || status === 410) return true;

  const msg = String(err?.message || err?.response?.data?.error || "").toLowerCase();
  if (msg.includes("404") || msg.includes("not found") || msg.includes("não encontrad")) {
    return true;
  }

  if (blob instanceof Blob) {
    if (blob.size === 0) return true;
    const type = (blob.type || "").toLowerCase();
    if (type.includes("text/html") || type.includes("application/json")) return true;
  }

  return false;
}

export function getQuickMessageMediaNotFoundMessage(shortcode) {
  return i18n.t("quickMessages.errors.mediaNotFound", {
    shortcode: shortcode ? ` (${shortcode})` : "",
  });
}

/**
 * Exibe toast específico para anexo ausente/corrompido. Retorna true se tratou o erro.
 */
export function toastQuickMessageMediaError(err, options = {}) {
  const { shortcode, blob } = options;

  if (!isQuickMessageMediaNotFound(err, blob)) {
    return false;
  }

  toast.error(getQuickMessageMediaNotFoundMessage(shortcode), {
    toastId: `quick-message-media-missing-${shortcode || "generic"}`,
    autoClose: 7000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    style: { zIndex: 10004 },
  });
  return true;
}

export function assertQuickMessageMediaBlob(blob) {
  if (isQuickMessageMediaNotFound(null, blob)) {
    const error = new Error("QUICK_MESSAGE_MEDIA_NOT_FOUND");
    error.response = { status: 404 };
    throw error;
  }
}

export function handleQuickMessageMediaFailure(err, options = {}) {
  if (toastQuickMessageMediaError(err, options)) return;
  toastError(err);
}

export default toastQuickMessageMediaError;
